import { createApp } from 'vue';
import { createPinia } from 'pinia';
import App from './App.vue';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap';
import router from './router';
import '@/assets/css/style.css';
import '@/assets/css/import-icons.css';
import '@fortawesome/fontawesome-free/css/all.min.css'

// Font Awesome
import { library } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
// Tüm fas ve far yerine sadece kullandığımız ikonları import edelim
import { 
  faHeart, 
  faUser, 
  // ... kullandığınız diğer ikonlar
} from '@fortawesome/free-solid-svg-icons'

import { 
  faFacebook, 
  faTwitter, 
  faInstagram, 
  faTiktok, 
  faPinterest, 
  faYoutube 
} from '@fortawesome/free-brands-svg-icons'

// Sadece kullandığımız ikonları ekleyelim
library.add(
  faHeart, 
  faUser,
  faFacebook, 
  faTwitter, 
  faInstagram, 
  faTiktok, 
  faPinterest, 
  faYoutube
)

const app = createApp(App);
const pinia = createPinia();


// Font Awesome bileşenini global olarak kaydet
app.component('FontAwesomeIcon', FontAwesomeIcon)

app.directive('scroll', {
  mounted(el) {
    window.addEventListener('scroll', () => {
      if (window.scrollY > 50) {
        el.classList.add('navbar_fixed');
      } else {
        el.classList.remove('navbar_fixed');
      }
    });
  }
});

app.use(pinia);
app.use(router);

app.mount('#app');


